import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import AboutPageHero from "../components/onlinePayments/AboutPageHero";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../components/onlinePayments/IntegrationOptions";
import Benefits from "../components/onlinePayments/Benefits";
import MerchantTermsAndConditionsDetails from "../pages/merchant-terms-conditions/MerchantTermsAndConditionsDetails";

const MerchantTermsAndConditions = () => {
  return (
    <Layout>
      <PageMeta />
      <Navbar />
      <MerchantTermsAndConditionsDetails />
      <Footer />
    </Layout>
  );
};

export default MerchantTermsAndConditions;
